const splitWithUnderscore = (value) => {
  // replace all spaces with underscores
  // split by underscores at any capital letters(except the first) then lowercase the whole thing
  return value
    .replace(/(?=[A-Z])/g, '_$')
    .replace(/[^a-zA-Z0-9]|\s/g, '_')
    .replace(/_{2,}/g, '_')
    .replace(/^_|_$/g, '')
    .toLowerCase();
};

const validateKey = (key) => /^[a-z0-9_]+$/.test(key);

export { splitWithUnderscore, validateKey };
